import {
	Breadcrumbs as MuiBreadcrumbs,
	Link,
	LinkProps,
	Typography
} from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import useBreadcrumbs from 'use-react-router-breadcrumbs';

interface LinkRouterProps extends LinkProps {
	to: string;
	replace?: boolean;
}

interface IBreadcrumbsRoute {
	path: string;
	breadcrumb: string;
}

interface IBreadcrumbsOptions {
	disableDefaults?: boolean;
	excludePaths?: string[];
	defaultFormatter?: (str: string) => string;
}

const LinkRouter = (props: LinkRouterProps) => (
	<Link
		{...props}
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		component={RouterLink as any}
		underline='hover'
	/>
);

const customRoutes: IBreadcrumbsRoute[] = [
	{
		path: '/templates/email/replication',
		breadcrumb: 'Email Template Replication'
	},
	{
		path: '/schedule/actions',
		breadcrumb: 'Scheduled Actions'
	},
	{
		path: '/settings/regioncampaigns',
		breadcrumb: 'Region Campaigns'
	}
];

const options: IBreadcrumbsOptions = {
	disableDefaults: false,
	excludePaths: ['/templates', '/templates/email', '/schedule', '/settings']
};

export const BreadCrumbs = () => {
	const breadcrumbs = useBreadcrumbs(customRoutes, options);
	return (
		<MuiBreadcrumbs
			sx={{
				ml: 2
			}}>
			{breadcrumbs.map((value, index) => {
				const last = index === breadcrumbs.length - 1;
				const color = last ? 'textPrimary' : 'inherit';
				return (
					<LinkRouter
						color={color}
						key={value.key}
						to={value.key}>
						<Typography variant='caption'>
							{value.breadcrumb}
						</Typography>
					</LinkRouter>
				);
			})}
		</MuiBreadcrumbs>
	);
};
